import React from 'react';
import { Box, Button, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const ChatFooter = ({ 
  input, 
  setInput, 
  selectedDataSource, 
  setSelectedDataSource, 
  availableSources, 
  isLoading, 
  isAdmin, 
  handleSendMessage,
  handleKeyPress 
}) => {
  return (
    <Box component="footer" className="chat-footer" sx={{ bgcolor: 'transparent', pt: 1.5, pb: 0, px: 0, borderTop: 'none' }}>
      <Box className="chat-input-container" sx={{ width: '100%', maxWidth: 'none', mx: 0 }}>
        <Box
          className="chat-input-wrapper"
          sx={{
            border: '1px solid #e5e5e5',
            borderRadius: '12px',
            p: 0.5,
            bgcolor: '#fff' // input wrapper stays pure white
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Write your message..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyPress={handleKeyPress}
            disabled={isLoading}
            inputProps={{ 'aria-label': 'Message input' }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '10px',
                backgroundColor: '#ffffff', // input bg white as per design
              },
              '& fieldset': { border: 'none' },
            }}
          />
        </Box>

        <Box
          className="footer-controls"
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },   // stack on small screens
            alignItems: { xs: 'stretch', sm: 'flex-end' },
            justifyContent: 'space-between',
            gap: { xs: 1.5, md: 2 },
            width: '100%',
            maxWidth: 'none',
            mx: 0,
            mt: { xs: 1, md: 1 },
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="data-source-label" sx={{ color: '#9ca3af' }}>Data source</InputLabel>
            <Select
              labelId="data-source-label"
              id="dataSource"
              value={selectedDataSource}
              label="Data source"
              onChange={(e) => setSelectedDataSource(e.target.value)}
              sx={{
                borderRadius: '10px',
                backgroundColor: '#f5f5f5', // subtle gray fill to match design
                '.MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' }, // light gray outline
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#cfd4db' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' },
                '& .MuiSvgIcon-root': { color: '#6b7280' }, // chevron color subtle gray
              }}
            >
              {availableSources.map(project => (
                <MenuItem key={project.id} value={project.id}>
                  {project.name}{project.usageCount > 0 ? ` - ${project.description || ''}` : ''}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            className="send-button"
            onClick={handleSendMessage}
            disabled={!input.trim() || isLoading}
            aria-label="Send message"
            variant="contained"
            color="primary"
            sx={{
              borderRadius: '8px',
              px: { xs: 2, md: 2.25 },
              height: 40,
              textTransform: 'none',
              fontWeight: 500,
              whiteSpace: 'nowrap',
              width: { xs: '100%', sm: 'auto' },  // full width on small screens
              alignSelf: { xs: 'stretch', sm: 'center' },
            }}
          >
            Send
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ChatFooter;
